import React from 'react';
import PropTypes from 'prop-types';
import { BoxNotification } from './styleNotification';

const Notification = props => (
  <BoxNotification title="Notificaciones" {...props} />
);

Notification.propTypes = {
  active: PropTypes.bool
};

export default Notification;
